import { Environment } from '~ratings/store/multi/environment/environment-types';

export const SET_ENVIRONMENT = 'SET_ENVIRONMENT' as const;
export const setEnvironment = (payload: Environment) => ({
  type: SET_ENVIRONMENT,
  payload,
});
